import { render } from "./ReplyModal.vue?vue&type=template&id=a52c14de&scoped=true"
import script from "./ReplyModal.vue?vue&type=script&lang=ts"
export * from "./ReplyModal.vue?vue&type=script&lang=ts"

import "./ReplyModal.vue?vue&type=style&index=0&id=a52c14de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a52c14de"

export default script